Auth = require 'db/auth'
trigger = require 'lib/util/event/trigger'
require 'whatwg-fetch'

window.Promise = require 'bluebird'
require('es6-object-assign').polyfill()

window.getAuthorization = ->
  type: 'cookie', token: Auth.myToken()

require 'intersection-observer'



// WEBPACK FOOTER //
// ./app/scripts/entry/globals.coffee